<template>
  <div id="app">
  <!-- Loader starts-->
    <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
  <!-- Loader ends-->

    <!--<Main/>-->

    <router-view></router-view>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'app',
  data(){
    return{
      show: true
    }
  },
  computed: {
    ...mapGetters(["estaActivo"])
  },
  created() {
    this.leerToken();    
  },
  mounted() {
      this.timeOut();
  },
  methods:{
     ...mapActions(["cerrarSesion", "leerToken"]),
    timeOut(){
          var self = this;
          setTimeout(function(){
              self.show = false;
          }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
